import BaseReducer from "../BaseReducer";
import FavoritesAction from "./favoritesAction";

export default class FavoritesReducer extends BaseReducer {
  initialState = {
    currentType: 'PROFILER',
    favoriteFilter: false,
    favorites: [],
  };

  /* SET ANY PROPERTY TO store*/
  [FavoritesAction.UPDATE_FAVORITES_STATE](state, action) {
    return {
      ...state,
      ...action.payload,
    }
  }

}
